export const ERROR_MODAL_CLOSE = 'ERROR_MODAL_CLOSE'

export const FETCH_MESSAGE = 'FETCH_MESSAGE'
export const FETCH_MESSAGE_FAIL = 'FETCH_MESSAGE_FAIL'
export const FETCH_MESSAGE_SUCCESS = 'FETCH_MESSAGE_SUCCESS'

export const FETCH_SUBSCRIBER = 'FETCH_SUBSCRIBER'
export const FETCH_SUBSCRIBER_FAIL = 'FETCH_SUBSCRIBER_FAIL'
export const FETCH_SUBSCRIBER_SUCCESS = 'FETCH_SUBSCRIBER_SUCCESS'

export const LOADING_SET = 'LOADING_SET'
export const LOADING_UNSET = 'LOADING_UNSET'
